import { store } from "../../stateManagement/store";
import { resetAuthAPI } from "./auth/authApi";
import { resetBaseAPI } from "./base/baseApi";
import { resetGeocoderAPI } from "./geocoder/geocoderApi";
import { resetMapWFSAPI } from "./mapWFS/mapWFSApi";
import { resetRosreestrAPI } from "./rosreestr/rosreestrApi";
import { resetIndorsoftRuAPI } from "./indorsoftRu/indorsoftRuApi";
import { resetTempDocumentsAPI } from "./tempDocuments/tempDocumentsApi";

export function resetAllApis() {
    const dispatch = store.dispatch
    dispatch(resetAuthAPI())
    dispatch(resetBaseAPI())
    dispatch(resetGeocoderAPI())
    dispatch(resetMapWFSAPI())
    dispatch(resetRosreestrAPI())
    dispatch(resetIndorsoftRuAPI())
    dispatch(resetTempDocumentsAPI())
}
